import { Button, Form, Input, message, Select, Skeleton } from 'antd';
import { useState } from 'react';
import { supabase } from '../../utils/supabase';
import Wrapper from '../Wrapper';
import useShopAttrs from '../../utils/hooks/useShopAttrs';
import { useSuspenseQuery } from '@tanstack/react-query';
import { categoriesQueryOptions } from '../../utils/queryOptions';

const ShopInfoForm = () => {

  const [disabled, setDisabled] = useState(true);

  const shopAttrs = useShopAttrs();
  const [form] = Form.useForm();

  const categories = useSuspenseQuery(categoriesQueryOptions());

  type FormValues = { business_name: string, vat: string, business_category: string }

  async function onFinish(values: FormValues) {
    setDisabled(true);
    const { data, error } = await supabase.from('shops').update(values).eq('id', shopAttrs.data.id);
    if (error) {
      message.error('Qualcosa è andato storto');
      return;
    }

    message.success('Informazioni aggiornate');
    await shopAttrs.invalidate();

  }


  return (
    <div>
      <Form onValuesChange={()=>setDisabled(false)} initialValues={{
        business_name: shopAttrs.data.business_name,
        vat: shopAttrs.data.vat,
        business_category: shopAttrs.data.business_category
      }} onFinish={onFinish} form={form} style={{ textAlign: 'right' }}
            layout={'vertical'}>
        <Form.Item name={'business_name'} label={'Nome del negozio'}>
          <Input size={'large'} />
        </Form.Item>
        <Form.Item name={'business_category'} label={'Categoria'}>
          <Select style={{ textAlign: 'left' }} size={'large'}>
            {categories.data.map((item) => (
              <Select.Option key={item.id} value={item.id}>{item.italian}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Button disabled={disabled} onClick={() => form.submit()} type={'primary'}>Salva</Button>
      </Form>
    </div>

  );
};
export default ShopInfoForm;
